/** Legacy decide/flags flat map: flag key → boolean or string. */
export type PostHogLegacyFeatureFlags = Record<string, boolean | string>;

/** PostHog `/flags?v=2` nested flag evaluation entry. */
export type PostHogFlagEvaluation = {
  key: string;
  enabled: boolean;
};

/** PostHog flags API body — supports legacy `featureFlags` and nested `flags`. */
export type PostHogFlagsApiResponse = {
  featureFlags?: PostHogLegacyFeatureFlags;
  flags?: Record<string, PostHogFlagEvaluation>;
};

/** Parse a boolean flag value from a legacy flat `featureFlags` map. */
export function parsePostHogBooleanFlag(
  featureFlags: PostHogLegacyFeatureFlags | undefined,
  flagKey: string,
  defaultValue: boolean
): boolean {
  const value = featureFlags?.[flagKey];
  if (value === undefined) return defaultValue;
  return value === true || value === 'true';
}

/**
 * Parse a boolean flag from a PostHog `/flags` or `/decide` response.
 * Prefers the nested `flags[key].enabled` shape (current API), then legacy `featureFlags`.
 */
export function parsePostHogBooleanFlagFromResponse(
  data: PostHogFlagsApiResponse | undefined,
  flagKey: string,
  defaultValue: boolean
): boolean {
  const nested = data?.flags?.[flagKey];
  if (nested !== undefined && typeof nested.enabled === 'boolean') {
    return nested.enabled;
  }
  return parsePostHogBooleanFlag(data?.featureFlags, flagKey, defaultValue);
}
